import { useEffect, useState } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { useGetRoleByIdQuery } from '../../queries';
import { useRoleSetupStore } from '../stores';

const TIMEOUT = 500;
const useRoleLoad = (id: string) => {
  const { isLoading: isRoleLoading, isSuccess, data } = useGetRoleByIdQuery({ id });
  const setState = useRoleSetupStore((state) => state.setState);
  const handleReset = useRoleSetupStore((state) => state.handleReset);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if(data) {
      const permissionIds = data.granted?.reduce((result: OptionKey[], item) => {
        const ids = item.options.map((option) => option.id);
        return [...result, ...ids];
      }, []);
      
      setState({
        ...data,
        permissions: permissionIds

      });
    }
  }, [data, setState]);
  useEffect(() => {
    if(isRoleLoading === false) {
      setTimeout(() => {
        setIsLoading(false);
      }, TIMEOUT);
    }
  }, [isRoleLoading]);

  useEffect(() => {
    return () => {
      handleReset();
    };
  }, [handleReset]);
  return {
    isSuccess,
    isLoading
  };
};

export default useRoleLoad;